export default "__VITE_ASSET__C6dsW501__"